import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CountyEngineersReportModel, PermitApplicationMonthlyTrackingReportModel, PermitApplicationTrackingSummaryReportModel, PermitsIssuedReportModel, RevenueByApplicationTypeReportModel, InsuranceDataListItem, FinancialComplianceProjectionRequest, StratigraphicApplicationReportModel } from "../models/adhoc-reports.model";
import { ReportSearchCriteria } from "../models/admin-reports.model";
import { OrganizationComplianceDetails } from "../../common/models/organization.model";
import { ContactSearchSpec, ContactHistorySearchSpec } from "../services/contacts.service";
import { ContactHistoryEvent } from "../models/contactHistory.model";

@Injectable()
export class AdhocReportsService {
    static readonly BaseUrl = 'api/ad-hoc-reports';

    constructor(public http: HttpClient) {
    }

    getInsuranceDataListReport(): Observable<InsuranceDataListItem[]> {
        return this.http.get<InsuranceDataListItem[]>(`${AdhocReportsService.BaseUrl}/insurance-data-list`);
    }

    getPermitApplicationsDetailedReportData(criteria: ReportSearchCriteria): Observable<any[]> {
        const query = this.buildParams(criteria);
        return this.http.get<any[]>(`${AdhocReportsService.BaseUrl}/permit-applications-detailed?${query}`);
    }

    getCountyEngineersReportData(criteria: ReportSearchCriteria): Observable<CountyEngineersReportModel[]> {
        const query = this.buildParams(criteria);
        return this.http.get<CountyEngineersReportModel[]>(`${AdhocReportsService.BaseUrl}/county-engineers?${query}`);
    }

    getPermitApplicationsTrackingSummaryReportData(criteria: ReportSearchCriteria): Observable<PermitApplicationTrackingSummaryReportModel> {
        const query = this.buildParams(criteria);
        return this.http.get<PermitApplicationTrackingSummaryReportModel>(`${AdhocReportsService.BaseUrl}/permit-applications-tracking-summary?${query}`);
    }

    getPermitApplicationsMonthlyTrackingReportData(criteria: ReportSearchCriteria): Observable<PermitApplicationMonthlyTrackingReportModel[]> {
        const query = this.buildParams(criteria);
        return this.http.get<PermitApplicationMonthlyTrackingReportModel[]>(`${AdhocReportsService.BaseUrl}/permit-applications-monthly-tracking?${query}`);
    }

    getPermitIssuedByProgramAreaReportData(criteria: ReportSearchCriteria): Observable<PermitsIssuedReportModel[]> {
        const query = this.buildParams(criteria);
        return this.http.get<PermitsIssuedReportModel[]>(`${AdhocReportsService.BaseUrl}/permits-issued-by-program-area-tracking?${query}`);
    }

    getRevenueByApplicationTypeReportData(criteria: ReportSearchCriteria): Observable<RevenueByApplicationTypeReportModel[]> {
        const query = this.buildParams(criteria);
        return this.http.get<RevenueByApplicationTypeReportModel[]>(`${AdhocReportsService.BaseUrl}/permit-revenue-by-application-type?${query}`);
    }

    projectFinancialCompliance(request: FinancialComplianceProjectionRequest): Observable<OrganizationComplianceDetails[]> {
        return this.http.post<OrganizationComplianceDetails[]>(`api/financial-assurance-reports/project-financial-compliance`, request);
    }

    getUserPermissionsReport(request: ContactHistorySearchSpec): Observable<ContactHistoryEvent[]> {
        return this.http.post<ContactHistoryEvent[]>(`${AdhocReportsService.BaseUrl}/user-permissions-report`, request);
    }

    getStratigraphicApplicationsReport(request: ReportSearchCriteria): Observable<StratigraphicApplicationReportModel[]> {
        return this.http.post<StratigraphicApplicationReportModel[]>(`${AdhocReportsService.BaseUrl}/stratigraphic-applications-report`, request);
    }

    getLastDataFacotryDate(): Observable<Date> {
        return this.http.get<Date>(`${AdhocReportsService.BaseUrl}/last-data-factory-date`);
    }

    private buildParams(criteria: ReportSearchCriteria): string {
        const params = new URLSearchParams();
        for (let key in criteria) {
            if (criteria.hasOwnProperty(key)) {
                const value = criteria[key];
                if (value instanceof Array) {
                    for (let index in value) {
                        if (value.hasOwnProperty(index)) {
                            params.set(key + "[" + index + "]", value[index]);
                        }
                    }                    
                } else if (value instanceof Date) {
                    params.set(key, value.toISOString());
                } else if (value != null) {
                    params.set(key, value);
                }
            }
        }
        return params.toString();
    }
}